import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';
import { ProgrammingUtilsService as Utils } from '../../common/services/utils.service';
import { SharedProgrammingService } from '../../common/services/shared-programming.service';

@Component({
  selector: 'prg-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.less']
})
export class ViewComponent extends BaseRoutingComponent implements OnInit {

  adding: Observable<boolean>;
  event: Observable<any>;

  constructor(
    protected router: Router,
    protected shared: SharedProgrammingService,
    protected store: Store<any>,
    private route: ActivatedRoute
  ) {
    super();

    this.adding = this.store.select(s => s.sharedProgramming.adding);
    this.event = this.store.select(s => s.sharedProgramming.trigger.event);
  }

  ngOnInit() {
    // this.shared.setTitle('Program Details');

    // this.shared.addBreadcrumb({ label: 'Details', route: Utils.getPathFromRoot(this.route) });
  }

  private edit() {
    this.router.navigate(['../edit'], { relativeTo: this.route });
  }

  private close() {
    this.router.navigate(['../programming'], { relativeTo: this.moduleRoot });
  }

  private preview() {
    // TODO
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/view/view.component.ts